/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class LocalFilterDialog
 * @hideconstructor
 * @classdesc API class that is used to obtain the handler to render the local filter dialog in the given render node
 */
define([], () => {
	class LocalFilterDialogAPI {
		/**
		 * @function LocalFilterDialogAPI#renderDialog
		 * @description Renders the local filter dialog in a given container
		 * @param {String} metadataColumnId the id of the metadata column
		 * @param {Object} renderNode The render node to render the filter dialog
		 * @param {Object} editorOptions - further options eg: { "placement": "auto", "attachPoint": ".slotEditor__localFilters__attachPoint"}
		 *			1) placement - placement overrides (eg auto)
		 *			2) forceOpen - when false, a filter entry can be replaced without launching the UI.
		 */
		renderDialog(/* metadataColumnId, renderNode, editorOptions */) {}

	}

	return LocalFilterDialogAPI;
});